import { ROUTER_BASEPATH } from "~/lib/routerBasepath";

/**
 * 計測で画面を識別する pathname に正規化する（basepath 除去・末尾スラッシュ除去）。
 * ルーターの location.pathname（basepath 込み）と match.pathname（basepath 無し）の両方を同じ形にする。
 */
export const normalizeScreenPathname = (pathname: string): string => {
  const withoutBase =
    ROUTER_BASEPATH && pathname.startsWith(ROUTER_BASEPATH)
      ? pathname.slice(ROUTER_BASEPATH.length)
      : pathname;
  const p = withoutBase || "/";
  return p.length > 1 && p.endsWith("/") ? p.slice(0, -1) : p;
};
